import {
  avatar_group_styles_default
} from "./chunk.P7WPWTIA.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/avatar-group/avatar-group.ts
var FadvAvatarGroup = class extends s {
  constructor() {
    super(...arguments);
    this.size = "small";
  }
  firstUpdated() {
    this.handleSlotChange();
  }
  handleSizeChange() {
    this.avatars.forEach((a) => a.size = this.size);
  }
  handleSlotChange() {
    this.avatars = [...this.children].filter((c) => hasTag(c, "fadv-avatar")).map((c) => {
      const avatar = c;
      avatar.size = this.size;
      return avatar;
    });
    this.avatarCount = this.avatars.length;
  }
  renderMenuItem(avatar) {
    return $`<fadv-menu-item @click=${() => avatar.click()} value=${avatar.label}>${avatar.label}</fadv-menu-item>`;
  }
  renderMenu() {
    var _a;
    if (!((_a = this.avatars) == null ? void 0 : _a.length))
      return w;
    if (this.avatarCount <= 4)
      return w;
    return $`<fadv-dropdown hoist distance="10" placement="bottom" class="avatar-group__dropdown"><button class="avatar-group__dropdown-button" slot="trigger">+${this.avatarCount - 4}</button><fadv-menu>${this.avatars.slice(4).map((a) => this.renderMenuItem(a))}</fadv-menu></fadv-dropdown>`;
  }
  render() {
    return $`<div class=${o({
      "avatar-group": true,
      "avatar-group--large": this.size === "large"
    })} @avatar-size-change=${this.handleSizeChange} ><slot @handleSlotChange=${this.handleSlotChange}></slot>${this.renderMenu()}</div>`;
  }
};
FadvAvatarGroup.styles = avatar_group_styles_default;
__decorateClass([
  t()
], FadvAvatarGroup.prototype, "avatarCount", 2);
__decorateClass([
  e({ reflect: true })
], FadvAvatarGroup.prototype, "size", 2);
__decorateClass([
  watch("size", { waitUntilFirstUpdate: true })
], FadvAvatarGroup.prototype, "handleSizeChange", 1);
FadvAvatarGroup = __decorateClass([
  n("fadv-avatar-group")
], FadvAvatarGroup);

export {
  FadvAvatarGroup
};
